import { Formik } from 'formik'
import { ButtonBlue } from 'components/common'
import { default as Cookies } from 'js-cookie'
import { useState, useEffect } from "react";
import { React, styled, Yup, mq } from 'x'
import {
  compose,
  lifecycle,
  pure,
  withHandlers,
  withState,
  withProps,
} from 'recompose'
import ip from 'library/ip'

import 'react-phone-number-input/style.css'
import PhoneInput, { isValidPhoneNumber } from 'react-phone-number-input'
import {
  getCountries,
  getCountryCallingCode,
} from 'react-phone-number-input/input'
import en from 'react-phone-number-input/locale/en.json'

import Arrow from '../static/svg/arrow.svg'

const DefaultFormWrapper = styled.form`
  transition:all 0.3s ease-in-out;
  display: flex;
  flex-flow: wrap;
  width: calc(100% + 50px);

  .PhoneInputCountry {
    background: #fff;
    padding: 15px;
    border-bottom: 3px solid ${(props) => props.theme.primaryRGBA(0.2)};

    --PhoneInputCountrySelectArrow-color: #000;
    --PhoneInputCountrySelectArrow-color--focus: #000;
    --PhoneInputCountryFlag-borderColor: #000;
  }

  .PhoneInputCountrySelect:focus + .PhoneInputCountryIcon--border {
    box-shadow: none;
  }

  .PhoneInputCountryIcon {
    border: none;
    box-shadow: none;
    background: transparent;
    font-size: 15px;
    width: auto;
  }

  .PhoneInputCountryIcon--border {
    border: none;
    box-shadow: none;
  }
`



const DefaultSubmitButton = styled(ButtonBlue)`
  margin-top: 35px;
`

const DefaultFieldGroup = styled.div`
  width: ${(props) => (props.fullWidth ? '100%' : 'calc(50% - 50px)')};
  margin-right: 50px;
  margin-bottom: 35px;

  label {
    display: block;
    font-size: 14px;
    font-weight: 600;
    line-height: 10px;
    letter-spacing: 1.2px;
    text-transform: uppercase;
    color: ${(props) => props.theme.primary};
    margin-bottom: 18px;
  }

  input[type='text'],
  input[type='email'],
  input[type='tel'],
  select,
  textarea {
    padding: 15px 15px;
    background: #fff;
    border: none;
    border-bottom: 3px solid ${(props) => props.theme.primaryRGBA(0.2)};
    font-size: 15px;
    line-height: 26px;
    width: 100%;
    box-sizing: border-box;
  }

  input,
  textarea {
    outline: none;
  }

  input.error,
  textarea.error {
    border-color: rgba(255, 0, 0, 0.6);
  }

  ${mq.below('lg')} {
    box-sizing: border-box;
    width: 100%;
    padding: 0 15px 0 0;
  }
`

export const DefaultFieldHeader = styled.p`
  position: relative;
  line-height: 16px;
  display: block;
  width: 100%;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 1.2px;
  text-transform: uppercase;
  color: ${(props) => props.theme.primary};
  margin-bottom: 28px;
`

const BusinessEnquiry = styled.div`
  ${DefaultFieldHeader} {
    margin-bottom: 20px;
  }
`

const BusinessEnquiryNew = styled.div`
  ${DefaultFieldHeader} {
    margin-bottom: 20px;
  }
  width:100%;
  display:flex;
  flex-wrap: wrap;

  & > div {
    @media screen and (max-width: 60em) {
      flex:1 1 100%;
      width: 100%;
      max-width:100%;
    }
    flex:1 1 calc(50% - 50px);
    width: calc(50% - 50px);
    max-width:calc(50% - 50px);
  }

  &.inactive {
    visibility: hidden;
    opacity:0;
    height:0;
    transition: all 0.3s ease-in-out;
  }

  &.active {
    visibility: visible;
    opacity:1;
    height:100%;
  }

  select {
    padding:15px !important;
  }
`

export const DefaultRadioFieldGroup = styled(DefaultFieldGroup)`
  display: flex;
  align-items0: center;
  padding-top: 8px;
  position: relative;
  box-sizing: border-box;

  label {
    position: relative;
    margin-bottom: 0;
    padding-left: 45px;
    line-height: 16px;
    margin-right: 40px;
  }
  input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }
  .bullet {
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    height: 30px;
    width: 30px;
    background-color: #fff;
    border-radius: 20px;
  }
  .bullet:after {
    content: '';
    position: absolute;
    display: none;
    left: 8px;
    top: 8px;
    width: 14px;
    height: 14px;
    border-radius: 20px;
    background-color: ${(props) => props.theme.primary};
  }
  label:hover input ~ .bullet:after {
    display: block;
    background-color: ${(props) => props.theme.primaryRGBA(0.2)};
  }
  label input:checked ~ .bullet {
    background-color: ${(props) => props.theme.primary};
  }
  label input:checked ~ .bullet:after {
    display: block;
    background-color: #fff;
  }
`

export const DefaultCheckboxFieldGroup = styled(DefaultFieldGroup)`
  display: flex;
  align-items: center;
  padding-top: 8px;
  position: relative;
  box-sizing: border-box;

  label {
    position: relative;
    margin-bottom: 0;
    padding-left: 45px;
    line-height: 16px;
  }
  input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }
  .checkmark {
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    height: 25px;
    width: 25px;
    background-color: #fff;
  }
  .checkmark:after {
    content: '';
    position: absolute;
    display: none;
    left: 9px;
    top: 5px;
    width: 5px;
    height: 10px;
    border: solid #fff;
    border-width: 0 3px 3px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
  }
  &:hover input ~ .checkmark:after {
    display: block;
    border-color: ${(props) => props.theme.primaryRGBA(0.2)};
  }
  input:checked ~ .checkmark {
    background-color: ${(props) => props.theme.primary};
  }
  input:checked ~ .checkmark:after {
    display: block;
    border-color: #fff;
  }
`

export const DefaultOptInCheckboxFieldGroup = styled(DefaultFieldGroup)`
  display: flex;
  flex-direction: column;
  padding-top: 8px;
  position: relative;
  box-sizing: border-box;
  width: 100%;
  margin-bottom: 0;
  padding-top: 0;

  label {
    position: relative;
    margin-bottom: 0;
    padding-left: 45px;
    line-height: 16px;
    text-transform: none;
    color: #fff;
    a {
      color: ${(props) => props.theme.primary};
      text-decoration: underline;
    }
  }
  input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }
  .checkmark {
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    height: 25px;
    width: 25px;
    background-color: #fff;
  }
  .checkmark:after {
    content: '';
    position: absolute;
    display: none;
    left: 9px;
    top: 5px;
    width: 5px;
    height: 10px;
    border: solid #fff;
    border-width: 0 3px 3px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
  }
  &:hover input ~ .checkmark:after {
    display: block;
    border-color: ${(props) => props.theme.primaryRGBA(0.2)};
  }
  input:checked ~ .checkmark {
    background-color: ${(props) => props.theme.primary};
  }
  input:checked ~ .checkmark:after {
    display: block;
    border-color: #fff;
  }
`

const DefaultError = styled.div`
  color: #fff;
  background: rgba(255, 0, 0, 0.6);
  padding: 10px;
`

export const OptIn = styled.div`
  display: flex;
  flex-flow: column;
  padding-top: 10px;
  border-top: 1px solid rgba(255, 255, 255, 0.7);
`

export const FieldContainer = styled.div`
  display: flex;
  flex-flow: column;
  padding-top: 10px;
  border-top: 0px solid rgba(255, 255, 255, 0.7);
  letter-spacing: 1.2px;
  text-transform: uppercase;
  color: #2A2D58;
`
export const HpField = styled.div`
  display: block;
  position: fixed;
  height: 1px;
  width: 1px;
  z-index:-1;
  bottom:-2000px;
`

const flags = {}
getCountries().forEach((country) => {
  flags[country] = () => <span>+{getCountryCallingCode(country)}</span>
})

const labels = {}
getCountries().forEach((country) => {
  labels[country] = `${en[country]} (+${getCountryCallingCode(country)})`
})

const defaults = {
  FormWrapper: DefaultFormWrapper,
  SubmitButton: DefaultSubmitButton,
  FieldGroup: DefaultFieldGroup,
  Error: DefaultError,
  CheckboxFieldGroup: DefaultCheckboxFieldGroup,
  OptInCheckboxFieldGroup: DefaultOptInCheckboxFieldGroup,
  FieldHeader: DefaultFieldHeader,
  enableFundedByCompany: true,
  enableComment: false,
  enableCorporate: true,
  RadioFieldGroup: DefaultRadioFieldGroup,
  formType: '',
}

export const CreateForm = (params) => {
  const {
    FormWrapper,
    SubmitButton,
    FieldGroup,
    Error,
    CheckboxFieldGroup,
    FindOutMore,
    enableFundedByCompany,
    enableComment,
    enableCorporate,
    OptInCheckboxFieldGroup,
    FieldHeader,
    RadioFieldGroup,
  } = Object.assign(defaults, params)

  const enhance = compose(
    pure,
    withState('prevent', 'setPrevent', true),
    withState('ipData', 'setIP', undefined),
    withProps({ formID: Math.random().toString(36).substr(2, 9) }),
    withHandlers(() => {
      let formRef
      return {
        registerChild: () => (ref) => {
          formRef = ref
        },
        formSubmit: (props) => (event, submitForm) => {
          // Only pass through Formik if prevent state is true
          if (props.prevent) {
            event.preventDefault()
            submitForm()
          }
        },
        onSubmit: (props) => async (values, formik) => {
          const {
            "email_address": emailaddress,
            "first_last_name": firstlastname,
            Email: em,
            'First Name': fn,
            'Last Name': ln,
            _Mobile: ph,
            'LEADCF256': LEADCF256,
            'Company': company,
            'LEADCF56' : licenses,
            'Number of Employees' : numem,
          } = values
          // console.log('Values:'+em +' - '+ ln+' - '+ ph + ' '+ LEADCF256);
          // console.log(values);
          dataLayer.push({
            emailaddress,
            firstlastname,
            em,
            fn,
            ln,
            ph,
            LEADCF256,
            licenses,
            numem,
            company,
          })

          // TODO _gaq.push(['_trackEvent', 'enquiry', this.getAttribute('data-formId')]);

          for (const [key, value] of Object.entries(values)) {
            // Checbox value, change to "on"
            if (value === true) {
              formik.setFieldValue(key, 'on')
            }
          }

          formik.setFieldValue(
            'LEADCF14',
            `http://www.ip-adress.com/ip_tracer/${props.ipData.ip}`,
            false
          )
          formik.setFieldValue('Mobile', values._Mobile, false)

          // Coming here means form validation is successful
          // Disable setPrevent so form submission is not prevented and resubmit form, browser will handle the rest
          // console.log(props.urlParams.pathname);
          // if(!emailaddress && !firstlastname && (props.urlParams.pathname == '/au/offers/it-training/ethical-hacker/' || props.urlParams.pathname == '/uk/offers/it-training/ethical-hacker/') ) {
          // if(!emailaddress && !firstlastname ) {            
          setTimeout(() => {
            props.setPrevent(false)
            formRef.submit()
          }, 100)
        // } 
        // if(props.urlParams.pathname != '/au/offers/it-training/ethical-hacker/' && props.urlParams.pathname != '/uk/offers/it-training/ethical-hacker/') {
        //   setTimeout(() => {
        //     props.setPrevent(false)
        //     formRef.submit()
        //   }, 100)          
        // }
        },
      }
    }),
    lifecycle({
      componentDidMount() {
        // In case of offerForm load ip and set returned promise globally on window so it only happens once
        if (this.props.isShown === undefined) {
          if (!window.load_ip) {
            window.load_ip = ip()
          }

          let setIP = this.props.setIP
          window.load_ip.then((data) => {
            setIP(data)
          })
        }
      },
      componentDidUpdate(prevProps) {
        if (this.props.isShown && !prevProps.isShown) {
          let setIP = this.props.setIP
          ip().then((data) => {
            // c onsole.log('got data', data)
            setIP(data)
          })
        }
      },
    })
  )

  const Form = (props) => {
    const formID = props.formID

    const fieldNameOverrides =
      {
        en: {
          LEADCF10: '',
        },
        au: {
          LEADCF4: 'LEADCF2',
          LEADCF5: 'LEADCF4',
          LEADCF6: 'LEADCF3',
          LEADCF7: 'LEADCF1',
          LEADCF14: 'LEADCF10',
          LEADCF10: '',
          LEADCF133: 'LEADCF109',
          LEADCF137: 'LEADCF104',
          LEADCF104: 'LEADCF103',
          LEADCF134: 'LEADCF108',
          LEADCF106: 'LEADCF110',
          LEADCF105: 'LEADCF101',
          LEADCF135: 'LEADCF107',
          LEADCF188: 'LEADCF28',
          LEADCF241: 'LEADCF105',
          LEADCF244: 'LEADCF131',

          LEADCF316: 'LEADCF36',
        },
      }[props.globalData.language.code] || {}

    const overrideOrDefault = (name) => fieldNameOverrides[name] || name

    // Corporate Filed Toggle State
    const [CorporateActive, setCorporateActive] = useState(false);

    const handleOnToggleCorporate = () => {
      setCorporateActive(!CorporateActive);
    };

    const closeCorporate = () => {
      setCorporateActive(false);
    };

    useEffect(() => {
      setCorporateActive(false);
    }, []);
    
    
    return (
      <Formik
        initialValues={{
          'email_address': '',
          'first_last_name': '',
          'First Name': '',
          'Last Name': '',
          Email: '',
          _Mobile: '',
          Mobile: '',
          Phone: '',
          'LEADCF256': false,
          'LEADCF56': '',
          Company: '',
          'Job Role': '',
          'Number of Licenses': '',
          'Number of Employees': '',
          Country: '',
          [overrideOrDefault('LEADCF188')]: '',
          [overrideOrDefault('LEADCF133')]: 'off',
          [overrideOrDefault('LEADCF14')]: '',
          [overrideOrDefault('LEADCF137')]: false,
          [overrideOrDefault('LEADCF104')]: false,
          [overrideOrDefault('LEADCF134')]: false,
          [overrideOrDefault('LEADCF106')]: false,
          [overrideOrDefault('LEADCF105')]: false,
          [overrideOrDefault('LEADCF135')]: false,
          [overrideOrDefault('LEADCF241')]: false,
          [overrideOrDefault('LEADCF244')]: false,

          [overrideOrDefault('LEADCF316')]: '',
        }}

        validationSchema={Yup.object().shape({
          'First Name': Yup.string()
            .trim()
            .required(
              props.globalData.contactRequiredFieldMessage.replace(
                '%s',
                `'${props.globalData.contactFirstName}'`
              )
            )
            .min(
              2,
              props.globalData.contactCharacterCheckMessage
                .replace('%s', `'${props.globalData.contactFirstName}'`)
                .replace('%d', 2)
            ),
          'Last Name': Yup.string()
            .trim()
            .required(
              props.globalData.contactRequiredFieldMessage.replace(
                '%s',
                `'${props.globalData.contactLastName}'`
              )
            )
            .min(
              2,
              props.globalData.contactCharacterCheckMessage
                .replace('%s', `'${props.globalData.contactLastName}'`)
                .replace('%d', 2)
            ),
          Email: Yup.string()
            .email(props.globalData.contactInvalidEmailMessage)
            .required(
              props.globalData.contactRequiredFieldMessage.replace(
                '%s',
                `'${props.globalData.contactEmail}'`
              )
            ),
          _Mobile: Yup.string()
            .trim()
            .required(
              props.globalData.contactRequiredFieldMessage.replace(
                '%s',
                `'${props.globalData.contactMobileNumber}'`
              )
            )
            .test(
              'is-valid-number',
              props.globalData.contactInvalidPhoneNumber,
              (value) => isValidPhoneNumber(value)
            ),
          [overrideOrDefault('LEADCF241')]: Yup.string().test(
            'is-not-false',
            props.globalData.contactOptin1Required,
            (value) => value !== 'false'
          ),
          LEADCF133: Yup.string(),
          Company: Yup.string().when("LEADCF133", {
              is: value => value === 'on',
              then: Yup.string()
                  .trim()
                  .required(
                    props.globalData.contactRequiredFieldMessage.replace(
                      '%s',
                      `'Company'`
                    )
                  ),
          }),

          'Job Role': Yup.string().when("LEADCF133", {
            is: value => value === 'on',
            then: Yup.string()
                .trim()
                .required(
                  props.globalData.contactRequiredFieldMessage.replace(
                    '%s',
                    `'Job Role'`
                  )
                ),
          }),

          'Number of Licenses': Yup.string().when("LEADCF133", {
            is: value => value === 'on',
            then: Yup.string()
                .trim()
                .required(
                  props.globalData.contactRequiredFieldMessage.replace(
                    '%s',
                    `'Number of Licenses'`
                  )
                ),
          }),

          'Number of Employees': Yup.string().when("LEADCF133", {
            is: value => value === 'on',
            then: Yup.string()
                .trim()
                .required(
                  props.globalData.contactRequiredFieldMessage.replace(
                    '%s',
                    `'Number of Employees'`
                  )
                ),
          }),

          'Country': Yup.string().when("LEADCF133", {
            is: value => value === 'on',
            then: Yup.string()
                .trim()
                .required(
                  props.globalData.contactRequiredFieldMessage.replace(
                    '%s',
                    `'Country'`
                  )
                ),
          }),
        })}
        onSubmit={props.onSubmit}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          submitForm,
          isSubmitting,
          setFieldValue,
        }) => {
          const formId = props.globalData.zohoFormId
          const salesIq = props.globalData.zohoSalesIq
          const extraField = props.globalData.zohoExtraFormField
          let thankYouPage = `${props.globalData.siteUrl}${props.globalData.thankYouPageUrl}`
          thankYouPage += `?email=${encodeURIComponent(values['Email'])}`
          thankYouPage += `&firstname=${encodeURIComponent(
            values['First Name']
          )}`
          thankYouPage += `&lastname=${encodeURIComponent(values['Last Name'])}`
          thankYouPage += `&phone=${encodeURIComponent(values['Mobile'])}`
          thankYouPage += `&LEADCF256=${encodeURIComponent(values['LEADCF256'])}`

          const utmSource = Cookies.get('utm_source') || 'direct'
          const utmMedium = Cookies.get('utm_medium')
          const utmCampaign = Cookies.get('utm_campaign')
          const gclid = Cookies.get('gclid')

          const campaignId = Cookies.get('campaign_id')

          let gclidValue = ''
          if (gclid && gclid !== 'undefined' && gclid !== '-') {
            gclidValue = gclid
          }

          const leadFields = {
            five: '',
            six: '',
            seven: '',
          }

          if (utmSource) {
            leadFields.five = utmSource
            leadFields.six = utmMedium
            leadFields.seven = utmCampaign
          }

          var zohoAdwordsTerm = '-'
          var zohoAdwordsContent = '-'
          if (props.urlParams && props.urlParams !== 'undefined') {
            const params = new URLSearchParams(props.urlParams.search)
            zohoAdwordsTerm = params.get('utm_term')
            zohoAdwordsContent = params.get('utm_content')
          }

          return (
            <FormWrapper
              id="formiQId1"
              className="fmt-form contact-form"
              ref={props.registerChild}
              action={'https://crm.zoho.com/crm/WebToLeadForm'}
              name={salesIq}
              method="post"
              data-formid={formId}
              onSubmit={(event) => props.formSubmit(event, submitForm)}
              siq_id={`autopick_9257-${formID}`}
            >
              {FindOutMore && (
                <FindOutMore>{props.globalData.stringFindOutMore}</FindOutMore>
              )}
              <HpField>
              <input id="email_address" type="number" autocomplete="off" name="email_address" onChange={handleChange} onBlur={handleBlur} value={values['email_address']} />                
              <input id="first_last_name" type="text" name="first_last_name" onChange={handleChange} onBlur={handleBlur} value={values['first_last_name']} />
              </HpField>
              <input
                type="hidden"
                name={overrideOrDefault('LEADCF4')}
                value={props.globalData.pageTitle}
                readOnly
              />
              <input
                type="hidden"
                name={overrideOrDefault('LEADCF5')}
                value={leadFields.five}
                readOnly
              />
              <input
                type="hidden"
                name={overrideOrDefault('LEADCF6')}
                value={leadFields.six}
                readOnly
              />
              <input
                type="hidden"
                name={overrideOrDefault('LEADCF7')}
                value={leadFields.seven}
                readOnly
              />
              <input
                type="hidden"
                name={overrideOrDefault('LEADCF316')}
                value={campaignId}
                readOnly
              />
              <input
                type="hidden"
                name="term"
                value={zohoAdwordsTerm}
                readOnly
              />
              <input
                type="hidden"
                name="content"
                value={zohoAdwordsContent}
                readOnly
              />
              <input type="hidden" name="segment" value="(not+set)" readOnly />
              <input
                type="hidden"
                name="xnQsjsdp"
                value={extraField}
                readOnly
              />
              <input
                type="hidden"
                id={`zc_gad-${formID}`}
                name="zc_gad"
                value=""
                readOnly
              />
              <input type="hidden" name="xmIwtLD" value={formId} readOnly />
              <input
                type="hidden"
                name="actionType"
                value="TGVhZHM="
                readOnly
              />
              <input
                type="hidden"
                name="returnURL"
                value={thankYouPage}
                readOnly
              />
              <input type="hidden" name="Lead Status" value="Fresh" readOnly />
              {fieldNameOverrides['LEADCF10'] !== '' && (
                <input
                  type="hidden"
                  name={overrideOrDefault('LEADCF10')}
                  value="learningpeople.com"
                  readOnly
                />
              )}
              <input type="hidden" name="LEADCF13" value="" readOnly />
              <input
                type="hidden"
                name={overrideOrDefault('LEADCF14')}
                value={values['LEADCF14']}
                readOnly
              />
              <input
                type="hidden"
                name="LEADCF40"
                value=""
                id={`ipcountry-${formID}`}
                readOnly
              />
              <input
                type="hidden"
                name="LEADCF171"
                value={gclidValue}
                readOnly
              />

              <FieldGroup>
                <label htmlFor={`form-firstname-${formID}`}>
                  {props.globalData.contactFirstName}
                </label>
                <input
                  id={`form-firstname-${formID}`}
                  type="text"
                  name="First Name"
                  placeholder=""
                  minLength="2"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values['First Name']}
                  className={
                    errors['First Name'] && touched['First Name'] ? 'error' : ''
                  }
                />
                {errors['First Name'] && touched['First Name'] && (
                  <Error>{errors['First Name']}</Error>
                )}
              </FieldGroup>
              <FieldGroup>
                <label htmlFor={`form-surname-${formID}`}>
                  {props.globalData.contactLastName}
                </label>
                <input
                  id={`form-surname-${formID}`}
                  type="text"
                  name="Last Name"
                  placeholder=""
                  minLength="2"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values['Last Name']}
                  className={
                    errors['Last Name'] && touched['Last Name'] ? 'error' : ''
                  }
                />
                {errors['Last Name'] && touched['Last Name'] && (
                  <Error>{errors['Last Name']}</Error>
                )}
              </FieldGroup>
              <FieldGroup>
                <label htmlFor={`form-email-${formID}`}>
                  {props.globalData.contactEmail}
                </label>
                <input
                  id={`form-email-${formID}`}
                  type="email"
                  name="Email"
                  placeholder=""
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.Email}
                  className={errors.Email && touched.Email ? 'error' : ''}
                />
                {errors.Email && touched.Email && <Error>{errors.Email}</Error>}
              </FieldGroup>
              <FieldGroup>
                <label htmlFor={`form-mobile-${formID}`}>
                  {props.globalData.contactMobileNumber}
                </label>
                <input type="hidden" name="Mobile" value={values.Mobile} />
                <PhoneInput
                  placeholder={props.globalData.contactPreferredNumber}
                  name="_Mobile"
                  flags={flags}
                  labels={labels}
                  defaultCountry={
                    props.ipData?.country_code
                      ? props.ipData.country_code
                      : props.post?.language?.code
                      ? props.post.language.code === 'en'
                        ? 'GB'
                        : 'AU'
                      : null
                  }
                  onChange={(value) => {
                    setFieldValue('_Mobile', value, true)
                  }}
                  onBlur={handleBlur}
                  value={values._Mobile}
                  className={errors._Mobile && touched._Mobile ? 'error' : ''}
                />
                {errors._Mobile && touched._Mobile && (
                  <Error>{errors._Mobile}</Error>
                )}
              </FieldGroup>

              {/*<FieldGroup>*/}
              {/*  <label htmlFor={`form-telephone-${formID}`}>{ props.globalData.contactLandlineNumber }</label>*/}
              {/*  <input id={`form-telephone-${formID}`}*/}
              {/*         type="tel"*/}
              {/*         name="Phone"*/}
              {/*         placeholder={ props.globalData.contactIncAreaAndCountryCode }*/}
              {/*         onChange={ handleChange }*/}
              {/*         onBlur={ handleBlur }*/}
              {/*         value={ values.Phone }*/}
              {/*  />*/}
              {/*</FieldGroup>*/}
              {enableComment && (
                <FieldGroup fullWidth>
                  <label htmlFor={`form-comment-${formID}`}>
                    {props.globalData.contactComment}
                  </label>
                  <textarea
                    id={`form-comment-${formID}`}
                    type="text"
                    name={overrideOrDefault('LEADCF188')}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values[overrideOrDefault('LEADCF188')]}
                    className={
                      errors[overrideOrDefault('LEADCF188')] &&
                      touched[overrideOrDefault('LEADCF188')]
                        ? 'error'
                        : ''
                    }
                  />
                  {errors[overrideOrDefault('LEADCF188')] &&
                    touched[overrideOrDefault('LEADCF188')] && (
                      <Error>{errors[overrideOrDefault('LEADCF188')]}</Error>
                    )}
                </FieldGroup>
              )}

              {enableFundedByCompany && (
                <BusinessEnquiry>
                  <FieldHeader>
                    {props.globalData.contactBusinessEnquiry}
                  </FieldHeader>
                  <RadioFieldGroup>
                    <label htmlFor={`radio-yes-${formID}`}>
                      {props.globalData.contactBusinessEnquiryYes}
                      <input
                        id={`radio-yes-${formID}`}
                        type="radio"
                        name={overrideOrDefault('LEADCF133')}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value="on"
                        onClick={handleOnToggleCorporate}
                      />
                      <span className="bullet" />
                    </label>
                    <label htmlFor={`radio-no-${formID}`}>
                      {props.globalData.contactBusinessEnquiryNo}
                      <input
                        id={`radio-no-${formID}`}
                        type="radio"
                        name={overrideOrDefault('LEADCF133')}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value='off'
                        onClick={() => closeCorporate()}
                      />
                      <span className="bullet" />
                    </label>
                  </RadioFieldGroup>
                </BusinessEnquiry>
              )}

            {props?.language?.prefix == 'uk' && (
              <BusinessEnquiry>
                <FieldHeader>
                  Member of Uk Armed Forces?
                  </FieldHeader>
                  <RadioFieldGroup>
                  <CheckboxFieldGroup>
                  <label>
                  
                    <div style={{'top': '-8px', 'position': 'relative'}}
                      dangerouslySetInnerHTML={{
                        __html:  `Yes`
                      }}
                    />
                   
                    <input
                      id="LEADCF256"
                      type="checkbox"
                      name="LEADCF256"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values[overrideOrDefault('LEADCF241')]}
                    />
                    <span className="checkmark" style={{'top': '0'}} />
                    
                  </label>
                  </CheckboxFieldGroup>
                  {errors[overrideOrDefault('LEADCF241')] &&
                    touched[overrideOrDefault('LEADCF241')] && (
                      <Error>{errors[overrideOrDefault('LEADCF241')]}</Error>
                    )}
                </RadioFieldGroup>
              </BusinessEnquiry>
            )}

              {/* Start Corporate */}
              {enableCorporate && CorporateActive === true ? (
              <BusinessEnquiryNew className={CorporateActive === true ? 'active' : 'inactive'} >
                <FieldGroup>
                  <label htmlFor={`form-company-${formID}`}>
                    Company
                  </label>
                  <input
                    id={`form-company-${formID}`}
                    type="text"
                    name="Company"
                    placeholder=""
                    minLength="2"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values['Company']}
                    className={
                      CorporateActive === true ? (errors['Company'] && touched['Company'] ? 'error' : '') : ''
                    }
                  />
                  {CorporateActive === true ? (
                    errors['Company'] && touched['Company'] && (
                      <Error>{errors['Company']}</Error>
                    )
                  ):null}

                </FieldGroup>
                <FieldGroup>
                  <label htmlFor={`form-jobrole-${formID}`}>
                    Job Role
                  </label>
                  <input
                    id="Job Role"
                    type="text"
                    name="Job Role"
                    placeholder=""
                    minLength="2"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values['Job Role']}
                    className={
                      CorporateActive === true ? (errors['Job Role'] && touched['Job Role'] ? 'error' : '') : ''
                    }
                  />
                  {CorporateActive === true ? (
                    errors['Job Role'] && touched['Job Role'] && (
                      <Error>{errors['Job Role']}</Error>
                    )
                  ):null}

                </FieldGroup>
                <FieldGroup>
                  <label htmlFor={`form-numberoflicenses-${formID}`}>
                  Number of Licenses
                  </label>
                  <input
                    id="Number of Licenses"
                    type="text"
                    name="Number of Licenses"
                    placeholder=""
                    minLength="1"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values['Number of Licenses']}
                    className={
                      CorporateActive === true ? (errors['Number of Licenses'] && touched['Number of Licenses'] ? 'error' : '') : ''
                    }
                  />
                  {CorporateActive === true ? (
                    errors['Number of Licenses'] && touched['Number of Licenses'] && (
                      <Error>{errors['Number of Licenses']}</Error>
                    )
                  ):null}
                </FieldGroup>   
                <FieldGroup>
                  <label htmlFor={`form-numberofemployees-${formID}`}>
                  Number of Employees
                  </label>
                  <input
                    id="Number of Employees"
                    type="text"
                    name="Number of Employees"
                    placeholder=""
                    minLength="1"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values['Number of Employees']}
                    className={
                      CorporateActive === true ? (errors['Number of Employees'] && touched['Number of Employees'] ? 'error' : '') : ''
                    }
                  />
                  {CorporateActive === true ? (
                    errors['Number of Employees'] && touched['Number of Employees'] && (
                      <Error>{errors['Number of Employees']}</Error>
                    )
                  ):null}
                </FieldGroup>  
                <FieldGroup>
                <label htmlFor={`form-country-${formID}`}>Country</label>
                <select className={
                      CorporateActive === true ? (errors['Country'] && touched['Country'] ? 'error zcwf_col_fld_slt' : 'zcwf_col_fld_slt') : 'zcwf_col_fld_slt'
                    } id='Country' name='Country' onChange={handleChange}
                    onBlur={handleBlur} style={{padding: '10px 5px'}}><option value='None'>None</option><option value='United&#x20;Kingdom'>United Kingdom</option><option value='Ireland'>Ireland</option><option value='Afghanistan'>Afghanistan</option><option value='Albania'>Albania</option><option value='Algeria'>Algeria</option><option value='American&#x20;Samoa'>American Samoa</option><option value='Andorra'>Andorra</option><option value='Angola'>Angola</option><option value='Anguilla'>Anguilla</option><option value='Antarctica'>Antarctica</option><option value='Antigua&#x20;and&#x20;Barbuda'>Antigua and Barbuda</option><option value='Argentina'>Argentina</option><option value='Armenia'>Armenia</option><option value='Aruban'>Aruban</option><option value='Australia'>Australia</option><option value='Austria'>Austria</option><option value='Azerbaijan'>Azerbaijan</option><option value='Bahamas'>Bahamas</option><option value='Bahrain'>Bahrain</option><option value='Bangladesh'>Bangladesh</option><option value='Barbados'>Barbados</option><option value='Belarus'>Belarus</option><option value='Belgium'>Belgium</option><option value='Belize'>Belize</option><option value='Benin'>Benin</option><option value='Bermuda'>Bermuda</option><option value='Bhutan'>Bhutan</option><option value='Bolivia'>Bolivia</option><option value='Bosnia&#x20;and&#x20;Herzegovina'>Bosnia and Herzegovina</option><option value='Botswana'>Botswana</option><option value='Bouvet&#x20;Island'>Bouvet Island</option><option value='Brazil'>Brazil</option><option value='British&#x20;Indian&#x20;Ocean&#x20;Territory'>British Indian Ocean Territory</option><option value='British&#x20;Virgin&#x20;Islands'>British Virgin Islands</option><option value='Brunei'>Brunei</option><option value='Bulgaria'>Bulgaria</option><option value='Burkina&#x20;Faso'>Burkina Faso</option><option value='Burundi'>Burundi</option><option value='Cambodia'>Cambodia</option><option value='Cameroon'>Cameroon</option><option value='Canada'>Canada</option><option value='Cape&#x20;Verde'>Cape Verde</option><option value='Cayman&#x20;Islands'>Cayman Islands</option><option value='Central&#x20;African&#x20;Republic'>Central African Republic</option><option value='Chad'>Chad</option><option value='Chile'>Chile</option><option value='China'>China</option><option value='Christmas&#x20;Island'>Christmas Island</option><option value='Cocos&#x20;Islands'>Cocos Islands</option><option value='Colombia'>Colombia</option><option value='Comoros'>Comoros</option><option value='Congo'>Congo</option><option value='Cook&#x20;Islands'>Cook Islands</option><option value='Costa&#x20;Rica'>Costa Rica</option><option value='Croatia'>Croatia</option><option value='Cuba'>Cuba</option><option value='Cyprus'>Cyprus</option><option value='Czech&#x20;Republic'>Czech Republic</option><option value='Cote&#x20;dIvoire'>Cote dIvoire</option><option value='Denmark'>Denmark</option><option value='Djibouti'>Djibouti</option><option value='Dominica'>Dominica</option><option value='Dominican&#x20;Republic'>Dominican Republic</option><option value='Ecuador'>Ecuador</option><option value='Egypt'>Egypt</option><option value='El&#x20;Salvador'>El Salvador</option><option value='Equatorial&#x20;Guinea'>Equatorial Guinea</option><option value='Eritrea'>Eritrea</option><option value='Estonia'>Estonia</option><option value='Ethiopia'>Ethiopia</option><option value='Falkland&#x20;Islands'>Falkland Islands</option><option value='Faroe&#x20;Islands'>Faroe Islands</option><option value='Fiji'>Fiji</option><option value='Finland'>Finland</option><option value='France'>France</option><option value='French&#x20;Guiana'>French Guiana</option><option value='French&#x20;Polynesia'>French Polynesia</option><option value='French&#x20;Southern&#x20;Territories'>French Southern Territories</option><option value='Gabon'>Gabon</option><option value='Gambia'>Gambia</option><option value='Georgia'>Georgia</option><option value='Germany'>Germany</option><option value='Ghana'>Ghana</option><option value='Gibraltar'>Gibraltar</option><option value='Greece'>Greece</option><option value='Greenland'>Greenland</option><option value='Grenada'>Grenada</option><option value='Guadeloupe'>Guadeloupe</option><option value='Guam'>Guam</option><option value='Guatemala'>Guatemala</option><option value='Guernsey'>Guernsey</option><option value='Guinea'>Guinea</option><option value='GuineaBissau'>GuineaBissau</option><option value='Guyana'>Guyana</option><option value='Haiti'>Haiti</option><option value='Heard&#x20;Island&#x20;And&#x20;McDonald&#x20;Islands'>Heard Island And McDonald Islands</option><option value='Honduras'>Honduras</option><option value='Hong&#x20;Kong'>Hong Kong</option><option value='Hungary'>Hungary</option><option value='Iceland'>Iceland</option><option value='India'>India</option><option value='Indonesia'>Indonesia</option><option value='Iran'>Iran</option><option value='Iraq'>Iraq</option><option value='Israel'>Israel</option><option value='Italy'>Italy</option><option value='Jamaica'>Jamaica</option><option value='Japan'>Japan</option><option value='Jersey'>Jersey</option><option value='Jordan'>Jordan</option><option value='Kazakhstan'>Kazakhstan</option><option value='Kenya'>Kenya</option><option value='Kiribati'>Kiribati</option><option value='Kosovo'>Kosovo</option><option value='Kuwait'>Kuwait</option><option value='Kyrgyzstan'>Kyrgyzstan</option><option value='Laos'>Laos</option><option value='Latvia'>Latvia</option><option value='Lebanon'>Lebanon</option><option value='Lesotho'>Lesotho</option><option value='Liberia'>Liberia</option><option value='Libya'>Libya</option><option value='Liechtenstein'>Liechtenstein</option><option value='Lithuania'>Lithuania</option><option value='Luxembourg'>Luxembourg</option><option value='Macao'>Macao</option><option value='Macedonia'>Macedonia</option><option value='Madagascar'>Madagascar</option><option value='Malawi'>Malawi</option><option value='Malaysia'>Malaysia</option><option value='Maldives'>Maldives</option><option value='Mali'>Mali</option><option value='Malta'>Malta</option><option value='Marshall&#x20;Islands'>Marshall Islands</option><option value='Martinique'>Martinique</option><option value='Mauritania'>Mauritania</option><option value='Mauritius'>Mauritius</option><option value='Mayotte'>Mayotte</option><option value='Mexico'>Mexico</option><option value='Micronesia'>Micronesia</option><option value='Moldova'>Moldova</option><option value='Monaco'>Monaco</option><option value='Mongolia'>Mongolia</option><option value='Montenegro'>Montenegro</option><option value='Montserrat'>Montserrat</option><option value='Morocco'>Morocco</option><option value='Mozambique'>Mozambique</option><option value='Myanmar'>Myanmar</option><option value='Namibia'>Namibia</option><option value='Nauru'>Nauru</option><option value='Nepal'>Nepal</option><option value='Netherlands'>Netherlands</option><option value='Netherlands&#x20;Antilles'>Netherlands Antilles</option><option value='New&#x20;Caledonia'>New Caledonia</option><option value='New&#x20;Zealand'>New Zealand</option><option value='Nicaragua'>Nicaragua</option><option value='Niger'>Niger</option><option value='Nigeria'>Nigeria</option><option value='Niue'>Niue</option><option value='Norfolk&#x20;Island'>Norfolk Island</option><option value='North&#x20;Korea'>North Korea</option><option value='Northern&#x20;Ireland'>Northern Ireland</option><option value='Northern&#x20;Mariana&#x20;Islands'>Northern Mariana Islands</option><option value='Norway'>Norway</option><option value='Oman'>Oman</option><option value='Pakistan'>Pakistan</option><option value='Palau'>Palau</option><option value='Palestine'>Palestine</option><option value='Panama'>Panama</option><option value='Papua&#x20;New&#x20;Guinea'>Papua New Guinea</option><option value='Paraguay'>Paraguay</option><option value='Peru'>Peru</option><option value='Philippines'>Philippines</option><option value='Pitcairn'>Pitcairn</option><option value='Poland'>Poland</option><option value='Portugal'>Portugal</option><option value='Puerto&#x20;Rico'>Puerto Rico</option><option value='Qatar'>Qatar</option><option value='Reunion'>Reunion</option><option value='Romania'>Romania</option><option value='Russia'>Russia</option><option value='Rwanda'>Rwanda</option><option value='Saint&#x20;Helena'>Saint Helena</option><option value='Saint&#x20;Kitts&#x20;And&#x20;Nevis'>Saint Kitts And Nevis</option><option value='Saint&#x20;Lucia'>Saint Lucia</option><option value='Saint&#x20;Pierre&#x20;And&#x20;Miquelon'>Saint Pierre And Miquelon</option><option value='Saint&#x20;Vincent&#x20;And&#x20;The&#x20;Grenadines'>Saint Vincent And The Grenadines</option><option value='Samoa'>Samoa</option><option value='San&#x20;Marino'>San Marino</option><option value='Sao&#x20;Tome&#x20;And&#x20;Principe'>Sao Tome And Principe</option><option value='Saudi&#x20;Arabia'>Saudi Arabia</option><option value='Senegal'>Senegal</option><option value='Serbia'>Serbia</option><option value='Serbia&#x20;and&#x20;Montenegro'>Serbia and Montenegro</option><option value='Seychelles'>Seychelles</option><option value='Sierra&#x20;Leone'>Sierra Leone</option><option value='Singapore'>Singapore</option><option value='Slovakia'>Slovakia</option><option value='Slovenia'>Slovenia</option><option value='Solomon&#x20;Islands'>Solomon Islands</option><option value='Somalia'>Somalia</option><option value='South&#x20;Africa'>South Africa</option><option value='South&#x20;Georgia&#x20;And&#x20;The&#x20;South&#x20;Sandwich&#x20;Islands'>South Georgia And The South Sandwich Islands</option><option value='South&#x20;Korea'>South Korea</option><option value='Spain'>Spain</option><option value='Sri&#x20;Lanka'>Sri Lanka</option><option value='Sudan'>Sudan</option><option value='Suriname'>Suriname</option><option value='Svalbard&#x20;And&#x20;Jan&#x20;Mayen'>Svalbard And Jan Mayen</option><option value='Swaziland'>Swaziland</option><option value='Sweden'>Sweden</option><option value='Switzerland'>Switzerland</option><option value='Syria'>Syria</option><option value='Taiwan'>Taiwan</option><option value='Tajikistan'>Tajikistan</option><option value='Tanzania'>Tanzania</option><option value='Thailand'>Thailand</option><option value='The&#x20;Democratic&#x20;Republic&#x20;Of&#x20;Congo'>The Democratic Republic Of Congo</option><option value='Timor-Leste'>Timor-Leste</option><option value='Togo'>Togo</option><option value='Tokelau'>Tokelau</option><option value='Tonga'>Tonga</option><option value='Trinidad&#x20;and&#x20;Tobago'>Trinidad and Tobago</option><option value='Tunisia'>Tunisia</option><option value='Turkey'>Turkey</option><option value='Turkmenistan'>Turkmenistan</option><option value='Turks&#x20;And&#x20;Caicos&#x20;Islands'>Turks And Caicos Islands</option><option value='Tuvalu'>Tuvalu</option><option value='Virgin&#x20;Islands'>Virgin Islands</option><option value='Uganda'>Uganda</option><option value='Ukraine'>Ukraine</option><option value='United&#x20;Arab&#x20;Emirates'>United Arab Emirates</option><option value='United&#x20;States'>United States</option><option value='United&#x20;States&#x20;Minor&#x20;Outlying&#x20;Islands'>United States Minor Outlying Islands</option><option value='Uruguay'>Uruguay</option><option value='Uzbekistan'>Uzbekistan</option><option value='Vanuatu'>Vanuatu</option><option value='Vatican'>Vatican</option><option value='Venezuela'>Venezuela</option><option value='Vietnam'>Vietnam</option><option value='Wallis&#x20;And&#x20;Futuna'>Wallis And Futuna</option><option value='Western&#x20;Sahara'>Western Sahara</option><option value='Yemen'>Yemen</option><option value='Zambia'>Zambia</option><option value='Zimbabwe'>Zimbabwe</option><option value='Aland&#x20;Islands'>Aland Islands</option></select>
                    {CorporateActive === true ? (
                      errors['Country'] && touched['Country'] && (
                        <Error>{errors['Country']}</Error>
                      )
                    ):null} 
                </FieldGroup>   
              </BusinessEnquiryNew>
              ):null}
              {/* End Corporate */}
              

            
              <OptIn>
                <OptInCheckboxFieldGroup>
                  <label htmlFor={`checkbox-optin1-${formID}`}>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: props.globalData.contactOptin1,
                      }}
                    />
                    <input
                      id={`checkbox-optin1-${formID}`}
                      type="checkbox"
                      name={overrideOrDefault('LEADCF241')}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values[overrideOrDefault('LEADCF241')]}
                    />
                    <span className="checkmark" />
                  </label>
                  {errors[overrideOrDefault('LEADCF241')] &&
                    touched[overrideOrDefault('LEADCF241')] && (
                      <Error>{errors[overrideOrDefault('LEADCF241')]}</Error>
                    )}
                </OptInCheckboxFieldGroup>
                <OptInCheckboxFieldGroup>
                  <label htmlFor={`checkbox-optin2-${formID}`}>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: props.globalData.contactOptin2,
                      }}
                    />
                    <input
                      id={`checkbox-optin2-${formID}`}
                      type="checkbox"
                      name={overrideOrDefault('LEADCF244')}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values[overrideOrDefault('LEADCF244')]}
                    />
                    <span className="checkmark" />
                  </label>
                </OptInCheckboxFieldGroup>
              </OptIn>
              <SubmitButton
                as="button"
                type="submit"
                disabled={isSubmitting}
                className={do {
                  const formType = props.formType || params.formType
                  // c onsole.log('formType', formType)
                  if (formType === 'bubble') 'submit-contact-bubble'
                  else if (formType === 'contactUs') 'submit-contact-us'
                  else if (formType === 'offer') `submit-offer-form`
                  else `submit-${formType}`
                }}
              >
                {props.globalData.contactSubmit}
                <Arrow className="circle" />
              </SubmitButton>
            </FormWrapper>
          )
        }}
      </Formik>
    )
  }

  return enhance(Form)
}

export default CreateForm()
